<template>
    <div>
        <rkm-row
            v-if="showLegend"
            class="mb-2"
        >
            <rkm-col>
                <rkm-alert color="warning">
                    <span>* Preenchimento obrigatório.</span>
                </rkm-alert>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <ValidationObserver
                    ref="observer"
                    slim
                    v-slot="{ handleSubmit, reset }"
                >
                    <b-form
                        @reset.prevent="reset"
                        @submit.prevent="validateOnSubmit ? onSubmit(handleSubmit) : null"
                    >
                        <slot />
                    </b-form>
                </ValidationObserver>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import {BForm} from 'bootstrap-vue'
import {ValidationObserver} from 'vee-validate'

export default {
    components: {BForm, ValidationObserver},
    methods: {
        onSubmit(handleSubmit) {
            handleSubmit(() => this.$emit('success'))
                .then(() => this.scrollToFirstInvalidField())
        },
        async validate(callbackOnSuccess) {
            const valid = await this.$refs.observer.validate()

            if (valid) {
                if (typeof callbackOnSuccess === 'function') {
                    callbackOnSuccess()
                }
            }
            else {
                this.scrollToFirstInvalidField()
            }

            return valid
        },
        validateSilent() {
            return this.$refs.observer.validate({ silent: true })
        },
        scrollToFirstInvalidField() {
            const error = this.$el.querySelector('.is-invalid')

            if (error) {
                const element = error.querySelector('input, select')
                error.scrollIntoView({ behavior: 'smooth', block: 'center' })

                if (element) {
                    element.focus({ preventScroll: true })
                }
            }
        },
        resetValidator() {
            this.$refs.observer.reset()
        },
    },
    props: {
        showLegend: {type: Boolean},
        validateOnSubmit: {type: Boolean},
    },
}
</script>